export type TermsType = 'TERMS_AND_CONDITIONS' | 'PRIVACY_STATEMENT' | 'VENDOR_TERMS';

export interface TermsUpdate {
  newTermsVersion: string;
  termsType: TermsType;
}
